export const BAN_PARTNER_REASONS: Record<string, string> = {
  fraud: "Fraudulent activity detected",
  violation: "Terms of service violation",
  other: "Other",
};
